import {Link} from "react-router-dom";

function Logo() {
    return (
        <div id="forehead">
            <Link id="logo" to="/">
                <img src="/images/erika-radich-logo.png" alt="Erika Radich"/>
            </Link>
        </div>
    );
}

export default Logo;